import React from 'react';
import T from 'prop-types';
import Input from '../../../components/Input/Input';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements';

const defaultValues = {
  cart: 'XXXX XXXX XXXX XXXX',
  cvc: 'XXX',
  date: 'XX/XX'
};

const elements = {
  cart: CardNumberElement,
  cvc: CardCVCElement,
  date: CardExpiryElement
};

const CardElement = ({
  type,
  isSubscribed = false,
  onReady,
  className,
  ...otherProps
}) => {
  const Element = elements[type];

  return isSubscribed ? (
    <Input
      disabled
      wrapperClassName={className}
      value={defaultValues[type]}
      {...otherProps}
    />
  ) : (
    <Element onReady={onReady} className={className} {...otherProps} />
  );
};

CardElement.propTypes = {
  type: T.oneOf(['cart', 'cvc', 'date']),
  isSubscribed: T.bool,
  className: T.string,
  onReady: T.func.isRequired
};

export default CardElement;



// WEBPACK FOOTER //
// ./src/containers/Billing/components/CardElement.jsx